import {InputTextarea} from "primereact/inputtextarea";
import Header from "../../../commun/Header/Header";
import {Dialog} from "primereact/dialog";
import {Button} from "primereact/button";
import classes from "./SparqlQuery.module.css";
import {classNames} from "primereact/utils";
import {useState} from "react";


const EditQueryDialog = ({currentQuery, isEditQueryVisible, closeDialog, saveDesc}) => {

    const [text, setText] = useState(currentQuery.content);

    const close = () => {
        closeDialog()
    }

    const save = () => {
        saveDesc(text)
    }


    return (
        <Dialog
            closable={false}
            closeOnEscape={false}
            modal={true}
            style={{width: '60vw', height: '30vw'}}
            onHide={close}
            visible={isEditQueryVisible}
        >
            <div className="flex-row mt-0">
                <div className="grid">
                    <div className="col-6">
                        <Header title={"Edit <" + currentQuery.name + ">"}/>
                    </div>
                    <div className={`col-6 ${classes.buttons}`} id={"dialog-header"}>
                        <Button key="save-btn" label="Apply"
                                className={classes.actionBtn}
                                type="button"
                                onClick={() => {
                                    save()
                                }}
                                disabled={currentQuery.queryType === "PythonScript"}

                        />
                        <Button id={"close-btn"}
                                key="close-btn"
                                type="button"
                                className={classNames(classes.actionBtn, classes.marginLeft)}
                                label="Cancel"
                                onClick={() => {
                                    close()
                                }
                                }
                        ></Button>
                    </div>

                </div>
                <InputTextarea
                    readOnly={currentQuery.queryType === "PythonScript"}
                    className={classes.inputStyle}
                    rows={5}
                    cols={30}
                    autoResize
                    defaultValue={`${currentQuery.content}`}
                    onChange={(e) => setText(e.target.value)}
                />
            </div>

        </Dialog>
    )
}
export default EditQueryDialog;
